import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME, LOGO_FOOTER } from '../../brand/brandAssets';
import NavItemLink from './NavItemLink';

function MobileMenu({ isOpen, onClose, nav = [], socials = [] }) {
    const [activeMenu, setActiveMenu] = useState(null);
    const menuRefs = useRef({});

    const toggleMenu = (index, hasChildren, e) => {
        if (!hasChildren) return;
        e.preventDefault();
        setActiveMenu(activeMenu === index ? null : index);
    };

    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height = activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
            }
        });
    }, [activeMenu]);

    return (
        <div
            className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}
        >
            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/" onClick={onClose} className="di-mobile-logo-link" aria-label={BRAND_NAME}>
                        <img src={LOGO_FOOTER} alt={BRAND_NAME} className="di-logo-full di-mobile-menu-logo" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        {nav.map((item, i) => {
                            const hasChildren = item.children?.length > 0;
                            return (
                                <li
                                    key={`${item.label}-${i}`}
                                    className={hasChildren ? `menu-item-has-children th-item-has-children ${activeMenu === i ? "th-active" : ""}` : ""}
                                >
                                    {hasChildren ? (
                                        <NavItemLink to={item.url || "#"} external={item.external} onClick={(e) => toggleMenu(i, true, e)}>
                                            {item.label}
                                        </NavItemLink>
                                    ) : (
                                        <NavItemLink to={item.url || "/"} external={item.external} onClick={onClose}>
                                            {item.label}
                                        </NavItemLink>
                                    )}
                                    {hasChildren && (
                                        <ul
                                            ref={(el) => (menuRefs.current[i] = el)}
                                            className="th-submenu"
                                            style={{ height: "0px", overflow: "hidden", transition: "height 0.3s ease-in-out" }}
                                        >
                                            {item.children.map((child, ci) => {
                                                if (child.isHeading) {
                                                    return (
                                                        <li key={`${child.label}-${ci}`} className="di-mobile-submenu-heading">
                                                            {child.label}
                                                        </li>
                                                    );
                                                }
                                                return (
                                                    <li
                                                        key={`${child.label}-${ci}`}
                                                        className={child.isViewAll ? "di-mobile-submenu-viewall" : ""}
                                                    >
                                                        <NavItemLink
                                                            to={child.url || "#"}
                                                            external={child.external}
                                                            onClick={onClose}
                                                        >
                                                            {child.label}
                                                        </NavItemLink>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </li>
                            );
                        })}
                        <li>
                            <Link to="/faq" onClick={onClose}>FAQ</Link>
                        </li>
                        <li>
                            <Link to="/contact" onClick={onClose}>Support</Link>
                        </li>
                    </ul>
                    <div className="mobile-menu-cta mt-4 px-3">
                        <Link to="/contact" className="th-btn th-btn-accent w-100 di-header-book-btn" onClick={onClose}>
                            Book Now
                        </Link>
                    </div>
                    {socials.length > 0 && (
                        <div className="di-mobile-menu-socials th-social">
                            {socials.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={s.label}
                                    onClick={onClose}
                                >
                                    <i className={s.icon} aria-hidden="true" />
                                </a>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
